import {Observable, of, retry, timer} from "rxjs";
import {StoreSelectorsService} from "../../app/services";
import {actionNetworkRequest} from "../../app/store/actions/user.actions";
import {Lib} from "../Lib";
import {ToastrService} from "ngx-toastr";
import {catchError} from "rxjs/operators";

const CONFIG = {count: 3, delay: 200, url: ''};

function backoffRetry<T>({count, delay, url} = CONFIG) {
    return (obs$: Observable<T>) => obs$.pipe(
        retry({
            count, delay: (error, retryIndex) => {
                const d = Math.pow(2, retryIndex - 1) * delay;
                console.log(`count ${retryIndex} of ${count}  delay ${delay} for ${url}`);
                if (retryIndex === count) {
                    console.error(`retryWithBackoff exceeded url: ${url} max: ${retryIndex}`);
                    return of(`network error ${url} ${count} ${error} ${error.message} ${error.statusText} ${error.url}`);
                }
                return timer(d);
            }
        })
    );
}

export function retryWithBackoff<U>(url: string, storeSelectorService: StoreSelectorsService, toastr: ToastrService, delayMs: number = 2000, maxRetry: number = 6): any {
    return <T>(src: Observable<T>): Observable<any> => {
        const retries = maxRetry;
        if (storeSelectorService) {
            storeSelectorService.dispatch(actionNetworkRequest({url}));
        }
        return src.pipe(
            backoffRetry({count: retries, delay: delayMs, url}),
            catchError((v) => {
                if (Lib.DevMode()) {
                    if (toastr) {
                        toastr.error(v.statusText, v.url);
                    } else {
                        alert(v.message);
                    }
                }
                return v;
            })
        );
    };
}

// return src.pipe(
//     retryWhen((errors: Observable<any>) => errors.pipe(
//         mergeMap(error => {
//                 if (retries-- > 0) {
//                     const backoffTime = delayMs + (maxRetry + retries) + backoffMs;
//                     // const backoffTime = delayMs * Math.pow(2, (maxRetry - retries));
//                     return of(error).pipe(delay(backoffTime));
//                 }
//                 if (Lib.DevMode()) {
//                     alert('Oops... problem with network, see dev console for more info');
//                 }
//                 console.error(`retryWithBackoff exceeded url: ${url} max: ${maxRetry} ${error} ${errors} ${error.status} ${error.statusText} ${error.url}`);
//                 return of(`network error ${error.statusText} ${url} ${maxRetry}`);
//             }
//         )
//     ))
// );
// export function dirtyCheck<U>(source: Observable<U>) {
//     return <T>(valueChanges: Observable<T>): Observable<any> => {
//         const isDirty$ = combineLatest(
//             source,
//             valueChanges,
//         ).pipe(
//             debounceTime(300),
//             map(([a, b]) => isEqualCheck(a, b) === false),
//             shareReplay({bufferSize: 1, refCount: true}),
//         );
//         return isDirty$;
//     };
// }



